import type { Activity, ActivityType, Intensity } from './types.js'

/**
 * Équivalents métaboliques moyens, d'après le Compendium of Physical Activities.
 * Volontairement grossiers : MovMania motive, il ne mesure pas.
 */
export const MET: Record<ActivityType, number> = {
  walk: 3.5,
  run: 9.8,
  bike: 7.5,
  swim: 7.0,
  strength: 5.0,
  yoga: 2.5,
  sport: 6.5,
  other: 4.0,
}

export function intensityOf(type: ActivityType): Intensity {
  const met = MET[type]
  if (met < 3) return 'light'
  if (met < 6) return 'moderate'
  return 'vigorous'
}

/**
 * Minutes comptabilisées au sens de la recommandation OMS.
 *
 * L'OMS recommande 150 min d'activité MODÉRÉE **ou** 75 min SOUTENUE par
 * semaine : une minute soutenue vaut donc deux minutes modérées. L'activité
 * légère (yoga doux, étirements) ne compte pas dans cet indicateur — c'est
 * volontaire, et c'est ce qui distingue cette jauge de l'objectif personnel,
 * où toutes les minutes comptent.
 */
export function whoMinutes(activity: Activity): number {
  switch (intensityOf(activity.type)) {
    case 'light':
      return 0
    case 'moderate':
      return activity.durationMin
    case 'vigorous':
      return activity.durationMin * 2
  }
}

/**
 * Minutes "d'effort ressenti" qui nourrissent la vitalité de l'avatar.
 * Contrairement à `whoMinutes`, le léger compte (pour moitié) : bouger un peu
 * vaut toujours mieux que ne pas bouger, et l'avatar doit le reconnaître.
 */
export function effortMinutes(activity: Activity): number {
  switch (intensityOf(activity.type)) {
    case 'light':
      return activity.durationMin * 0.5
    case 'moderate':
      return activity.durationMin
    case 'vigorous':
      return activity.durationMin * 2
  }
}

/** kcal ≈ MET × poids(kg) × durée(h). Estimation indicative. */
export function estimateKcal(activity: Activity, weightKg = 70): number {
  return Math.round(MET[activity.type] * weightKg * (activity.durationMin / 60))
}

export function activityDate(activity: Activity): Date {
  return new Date(activity.startedAt)
}
